import loginTypes from './types'

const initialState = {
  isLogged: false,
  isLoading: false,
  formError: ''
}

const LoginReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case loginTypes.SET_IS_LOGGED:
      return {
        ...state,
        isLogged: payload.isLogged
      }

    case loginTypes.LOGIN:
      return {
        ...state,
        isLoading: true,
        formError: '',
        isLogged: false
      }

    case loginTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        formError: '',
        isLogged: true
      }

    case loginTypes.LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        formError: payload.formError,
        isLogged: false
      }

    case loginTypes.LOGOUT:
      return {
        ...state,
        isLoading: false,
        formError: '',
        isLogged: false
      }

    default:
      return state
  }
}

export default LoginReducer
